module.exports = __webpack_public_path__ + "img/logo-full.f33974a4.svg";